import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Select, notification} from 'antd';

import {getDescriptionFromError} from "../utils/errors";
import {addTaxToGroup, getTaxes, getTaxGroup} from "./actions";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddTaxToGroupForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.taxGroupId !== this.props.match.params.taxGroupId) {
      this._load();
    }
  }

  _load = () => {
    const {salonId} = this.props;
    const {taxGroupId} = decodeParams(this.props.match.params);
    this.props.getTaxes({salonId});
    this.props.getTaxGroup({taxGroupId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {taxGroupId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addTaxToGroup({...values, taxGroupId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, taxGroup, taxes} = this.props;
    return (
      <Card title="Add Tax Group">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Tax Group"
          >
            {taxGroup.name}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Tax"
          >
            {getFieldDecorator('taxId', {
              rules: [{
                required: true,
                message: 'Tax is required'
              }]
            })(
              <Select>
                {taxes.map(tax =>
                  <Option key={tax.taxId} value={tax.taxId}>{tax.name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Add Tax To Group
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddTaxToGroupForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  salonId: PropTypes.string.isRequired,
  addTaxToGroup: PropTypes.func.isRequired,
  getTaxes: PropTypes.func.isRequired,
  taxes: PropTypes.array.isRequired,
  getTaxGroup: PropTypes.func.isRequired,
  taxGroup: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const AddTaxToGroupPage = Form.create()(AddTaxToGroupForm);

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  taxes: state.tax.taxes,
  taxGroup: state.tax.taxGroup || {},
  loading: state.tax.taxesLoading || state.tax.gettingTaxGroup || state.tax.addingTaxToGroup,
});

const mapDispatchToProps = dispatch => ({
  getTaxes: payload => (dispatch(getTaxes(payload))),
  getTaxGroup: payload => (dispatch(getTaxGroup(payload))),
  addTaxToGroup: payload => (dispatch(addTaxToGroup(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddTaxToGroupPage);



// WEBPACK FOOTER //
// ./src/Tax/AddTaxToGroupPage.js